<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-filters">
        <div class="filter-list">
          <div class="filter-item">
            <span class="title">Name:</span>
            <el-input class="content" placeholder="Search by name" v-model="filter.name" size="small" clearable @change="changeFilter"></el-input>
          </div>
        </div>
        <div class="filter-actions">
          <el-button class="el-btn-blue" size="small" @click="changeFilter">Search</el-button>
          <el-button class="action-reset" size="small" @click="resetFilter">Reset</el-button>
        </div>
      </div>
      <div class="main-actions">
        <el-button class="el-btn-blue" size="small" icon="el-icon-plus" @click="newSubCategory()">New Sub SubCategory</el-button>
      </div>
      <div class="main-table">
        <el-table :data="subCategories" v-loading="flagLoading.getSubCategories" border>
          <el-table-column type="index" label="#" :index="generateIndex" width="100" />
          <el-table-column prop="category_name" label="Category" />
          <el-table-column prop="name" label="Sub Category" />
          <el-table-column label="Status">
            <template #default="scope">
              <span>{{ generateStatus(scope.row.is_published) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Last updated">
            <template #default="scope">
              <span>{{ generateTime(scope.row.updated_at) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Operate">
            <template #default="scope">
              <div class="table-operate">
                <div class="operate-item">
                  <el-button size="small" type="text" class="el-btn-blue" @click="editSubCategory(scope.row)">Edit</el-button>
                </div>
                <div class="operate-item">
                  <el-popconfirm
                    title="Confirm to delete this record?"
                    @confirm="deleteSubCategory(scope.row)"
                  >
                    <template #reference>
                      <el-button size="small" type="text" class="el-btn-blue">Delete</el-button>
                    </template>
                  </el-popconfirm>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="common-pagination" background layout="prev, pager, next"
          :current-page="pageNum" :page-size="pageSize" :total="totalNum"
          @current-change="changeCurrentPage"
        />
      </div>
    </div>
    <ModalSubCategory
      v-bind:flagVisible="flagVisible.modalSubCategory" v-on:closeModal="flagVisible.modalSubCategory = false"
      v-bind:categories="categories" v-bind:actionItem="actionItems.subCategory" v-on:reloadData="reloadData"
    />
  </div>
</template>

<script>
import { reactive } from 'vue'
import moment from 'moment'
import ModalSubCategory from './modals/SubCategory.vue'
export default {
  name: 'GlobalSubCategories',
  components: {
    ModalSubCategory
  },
  data () {
    const filter = reactive({
      name: ''
    })
    const flagLoading = reactive({
      getSubCategories: false
    })
    const flagVisible = reactive({
      modalSubCategory: false
    })
    const actionItems = reactive({
      subCategory: {
        _id: '',
        category_id: '',
        name: ''
      }
    })
    return {
      categories: [],
      subCategories: [],
      pageNum: 1,
      pageSize: 20,
      totalNum: 0,
      filter,
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: async function () {
    await this.getCategories()
    this.getSubCategories()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getCategories: async function () {
      const url = '/api/v1/atk_player/admin/categories?page_num=1&page_size=100&is_deleted=false'
      const that = this
      await this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.categories = res.data.list
        }
      }).catch(function (err) {
        console.error('getCategories', err)
      })
    },
    getSubCategories: function () {
      this.flagLoading.getSubCategories = true
      const { pageNum, pageSize, filter } = this
      let url = `/api/v1/atk_player/admin/sub_categories?page_num=${pageNum}&page_size=${pageSize}&is_deleted=false`
      if (filter.name) url += `&name=${encodeURIComponent(filter.name)}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.subCategories = res.data.list
          that.totalNum = res.data.total_num
        }
        that.flagLoading.getSubCategories = false
      }).catch(function (err) {
        console.error('getSubCategories', err)
        that.flagLoading.getSubCategories = false
      })
    },
    generateTime: function (time) {
      const tz = moment().utcOffset()
      return moment(time).utcOffset(tz).format('D MMM YYYY HH:mm')
    },
    generateStatus: function (published) {
      let str = ''
      switch (`${published}`) {
        case '1':
          str = 'Active'
          break
        case '0':
          str = 'Pending'
          break
      }
      return str
    },
    changeCurrentPage: function (page) {
      this.pageNum = page
      this.getSubCategories()
    },
    changeFilter: function () {
      this.pageNum = 1
      this.getSubCategories()
    },
    resetFilter: function () {
      this.filter = { name: '' }
      this.pageNum = 1
      this.getSubCategories()
    },
    generateIndex: function (index) {
      const { pageNum, pageSize } = this
      return index + 1 + pageSize * (pageNum - 1)
    },
    newSubCategory: function () {
      const actionSubCategory = this.actionItems.subCategory
      if (actionSubCategory._id) {
        this.actionItems.subCategory = {
          _id: '',
          category_id: '',
          name: ''
        }
      }
      this.flagVisible.modalSubCategory = true
    },
    editSubCategory: function (subCategory) {
      this.$router.push({ path: `/global/sub_categories/${subCategory._id}/edit` })
    },
    reloadData: function () {
      this.actionItems.subCategory = {
        _id: '',
        category_id: '',
        name: ''
      }
      this.getSubCategories()
    },
    deleteSubCategory: function (subCategory) {
      const url = `/api/v1/atk_player/admin/sub_categories/${subCategory._id}`
      const that = this
      this.$service.delete(url).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Delete success' })
          that.getSubCategories()
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
      }).catch(function (err) {
        console.error('deleteSubCategory', err)
      })
    }
  }
}
</script>
